import { ENV } from '@/env';

export const getApiUrl = () => {
  // only for local development
  if (ENV.API_PROXY_URL) {
    return ENV.API_URL;
  }

  return window.origin.replace('chauffeur', 'api');
};
